import { createSelector } from 'reselect';

import { formatTime } from '../../utils';
import { RootState } from '../models';

export const selectFormattedCurrentTime = createSelector(
  (state:RootState) => state.video.currentTime,
  (state:RootState) => state.video.duration, 
  (currentTime:number, duration:number) => formatTime(currentTime, duration > 3600)
);